import axiosInstance from './instance';

const langApi = {
  // 전체 캠퍼스
  guestBrands(brandCode: string) {
    return axiosInstance.get(`/guest/brands`);
  },

  // 단일 캠퍼스
  guestBrand(brandCode: string) {
    return axiosInstance.get(`/guest/${brandCode}/brand`);
  },

  // 게스트 언어팩
  guestLanguagePack(brandCode: string) {
    return axiosInstance.get(`/guest/${brandCode}/i18n/language/pack`);
  },

  // 게스트 기본 언어팩
  guestLanguageDefault(brandCode: string) {
    return axiosInstance.get(`/guest/${brandCode}/i18n/language/default`);
  },

  // 유저 기본 언어 팩
  getUserLanguageDefault() {
    return axiosInstance.get(`/i18n/language/default`);
  },

  // 유저 언어 팩
  getUserLanguageDefaultPack() {
    return axiosInstance.get(`/i18n/language/pack`);
  },

  // 국가 코드(Country code)
  guestCountryList(params: { brandCode: string }) {
    return axiosInstance.get(`/guest/${params.brandCode}/i18n/country/list`);
  },
};

export default langApi;

/*
i18n 유틸 함수 생성
getDefaultLanguage
  유저가 설정한 언어가 있는 경우 || 유저가 설정한 언어가 없는 경우 -> 캠퍼스 기본 언어 사용
  유저가 설정한 언어가 없는 경우 endpoint : /guest/${params.brandCode}/i18n/language/default

setUserLanguage
  endpoint : /guest/${params.brandCode}/i18n/language/pack
  플로우
    캠퍼스에 해당하는 전체 언어팩 요청
    getDefaultLanguage에서 이미 설정한 언어팩이 있는지 확인 && 다운로드 받은 언어팩에 이미 설정한 언어팩이 있는지 확인
    2번의 로직이 맞으면 이미 설정한 언어팩으로 다운로드
    2번의 로직에 안맞으면 캠퍼스 기본 언어팩 다운로드 (getDefaultLanguage)

setLanguage
  해당 언어 데이터로
    날짜 유형 변경
    HTML 언어 변경
    localStorage에 해당 언어 데이터 저장
  다운 받은 언어팩의 staticFile url로 데이터 다운로드
  다운받은 언어팩 데이터(json)로 i18n 설정
*/
